import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import PropTypes from "prop-types";
import dayjs from "dayjs";

import Popup from "@propellerads/popup";
import Button, { BUTTON_TYPE } from "@propellerads/button";
import Alert from "@propellerads/alert";
import DOMPurify from "dompurify";

import Translate from "Components/Translate";

import { markAsRead as markAsReadAction } from "actions/singleNotifications";

import notificationMessageShape from "../notificationMessage.shape";

import "./styles.scss";

const FROM_UTC_TO_EST_IN_MINUTES = 300;

const SingleNotification = ({ message, markAsRead }) => {
  const date = new Date();
  const timezoneOffsetInMinutes =
    date.getTimezoneOffset() - FROM_UTC_TO_EST_IN_MINUTES;
  const now = dayjs().add(timezoneOffsetInMinutes, "minute");

  const [isPopupOpened, setIsPopupOpened] = useState(false);
  const [isMessageVisible, setIsMessageVisible] = useState(false);

  const fromDate =
    message && message.date_from ? dayjs(message.date_from) : now;
  const toDate =
    message && message.date_to
      ? dayjs(message.date_to)
      : dayjs().add(20, "year");

  useEffect(() => {
    if (message && !message.read && isPopupOpened) {
      window.setTimeout(() => {
        if (message && !message.read) {
          markAsRead(message);
        }
      }, 1500);
    }
  }, [isPopupOpened, markAsRead, message]);

  useEffect(() => {
    const current = dayjs().add(timezoneOffsetInMinutes, "minute");
    if (!message || fromDate > current || toDate < current) {
      setIsMessageVisible(false);
    } else {
      setIsMessageVisible(true);
    }

    const interval = setInterval(() => {
      const now = dayjs().add(timezoneOffsetInMinutes, "minute");
      if (toDate < now) {
        setIsMessageVisible(false);
      } else if (fromDate <= now) {
        setIsMessageVisible(true);
      }
    }, 20000);

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [message, fromDate, toDate, timezoneOffsetInMinutes]);

  if (!isMessageVisible) {
    return null;
  }

  return (
    <div className="SingleNotification">
      <Alert>
        <div className="SingleNotification__content">
          <div
            className="SingleNotification__short-content"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(message.short_content),
            }}
          />
          <div className="SingleNotification__button">
            <Button
              elementId="single-notification-read-more-button"
              type={BUTTON_TYPE.PLAIN}
              onClick={() => setIsPopupOpened(true)}
            >
              <span className="SingleNotification__link">
                <Translate tag="read_more" />
              </span>
            </Button>
          </div>
        </div>

        {isPopupOpened && (
          <Popup
            closePopupHandler={setIsPopupOpened}
            header={<strong>{message.title}</strong>}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(message.content),
              }}
            />
          </Popup>
        )}
      </Alert>
    </div>
  );
};

SingleNotification.propTypes = {
  message: PropTypes.shape(notificationMessageShape),
  markAsRead: PropTypes.func.isRequired,
};

SingleNotification.defaultProps = {
  message: undefined,
};

const mapDispatchToProps = (dispatch) => {
  return {
    markAsRead: (message) => dispatch(markAsReadAction(message)),
  };
};

export default connect(null, mapDispatchToProps)(SingleNotification);
